<template>
  <div class=" ">
     
    <div   class="mr-auto">
 <!-- {{ item }} -->
      <h4 class="font-weight-normal  pb-0 mb-0 text-black" style="white-space: normal !important;">
          {{ itemNombre }}
      </h4>
      <span class="font-weight-black   ">{{ $t('agents.realEstateAdvisor') }}</span>
 
    </div>

      <div style="width: 100%;"  class="pt-2 text-black altura-card-footer-propiedades">
      <div  class=" text-secondary">
        <div v-if="item.Celular" class=" pr-2 px-0 d-flex justify-content-start py-1">
          <i class="fa-solid pt-1 fa-phone mr-1"></i>
          <span>{{ formatPhoneNumber(item.Celular ) }} </span>
        </div>
        <div v-if="item.Email" class=" pr-2 px-0 d-flex justify-content-start py-1"> 
          <i class="fa-regular pt-1 fa-envelope mr-1"></i>
          <span>{{ item.Email }}</span>
        </div>
        
      </div>
      <div class="d-flex">

        <div class="ml-auto">
          <router-link :to="agentPath" class="text-primary pointer zoom">{{ $t('agents.viewProfile') }}<i class="ml-2 fa-solid fa-arrow-right"></i></router-link>
           
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buildAgentPath } from "@/utils/agentUrl";
import { tFieldOrValue } from "@/i18n";

export default {
  props: [" detail", "detailCardAgente"],
  data() {
    return {
      item: {}, // Aquí se cargarán los datos desde JSON o se inicializarán directamente
    };
  },
  computed: {
    // Locale reactivo
    currentLocale() {
      return this.$i18n.locale;
    },
    // Agente.Nombre suele venir como `Nombre_Esp`/`Nombre_Eng`; tFieldOrValue
    // cae al campo plano `Nombre` si la API no devuelve los sufijos.
    itemNombre() {
      return tFieldOrValue(this.item, "Nombre", this.currentLocale);
    },
    agentPath() {
      return buildAgentPath(this.item);
    },
  },
  methods: {
    formatPhoneNumber(phone) {
      if (!phone) return "";

      const digits = phone.toString().replace(/\D/g, "");

      const countryCode = digits.slice(0, 3); // 505
      const localNumber = digits.slice(3);    // 55047184

      const formattedLocal = localNumber.match(/.{1,4}/g)?.join(" ") || localNumber;

      return `+${countryCode} ${formattedLocal}`;
    },
    goToAbout() {
      this.$router.push('/agentes');
    }
  },

  mounted() {
    this.item = this.detailCardAgente
    // Intentar cargar desde un archivo JSON. Si falla, usa datos locales.
    
  },
};
</script>

<style lang="scss" scoped>

.arrow {
      position: absolute;
      // top: 50%;
      // left: -50px;
      // transform: translateY(-50%);
      // font-size: 2rem;
      animation: moveArrow 2s infinite linear;
    }

    @keyframes moveArrow {
      0% {
        left: -5px;
      }
      100% {
        left: 5px;
      }
    }
/* Estilos reutilizados */
.altura-card-detalle-propiedades {
  height: 6rem !important;
}

.altura-card-footer-propiedades {
  height: auto !important;
}

.text-card1 {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}



.ml-auto {
  margin-left: auto;
}
</style>
